import { Panel } from "@/components/ui/Panel";
import { refusalDetail } from "@/services/api-client";

const UNREACHED = "The change did not reach the server.";

/** A refused reshape, in the server's words. */
export function Refusal({ error }: { error: unknown }) {
  return (
    <Panel
      as="p"
      role="alert"
      tone="destructive"
      pad="tight"
      className="mt-2 text-[12px]"
    >
      {refusalDetail(error, UNREACHED)}
    </Panel>
  );
}
